<section id="sign-up" class="sign-up section-auth">
  <div class="container">
    <div class="row">
      <div class="auth-wrapper">
        <!-- LEFT BRAND / HERO PANEL -->
        <aside class="auth-hero">
          <!-- <div class="brand">
            <div class="brand-logo">AIO</div>
            <div class="brand-name">All-In-One Invoice</div>
          </div> -->

          <h1 class="hero-heading">
            Create your account.
          </h1>

          <p class="hero-text">
            Start sending professional invoices, tracking payments, and managing clients with AllInOneInvoices in just a few steps.
          </p>

          <div class="hero-badges">
            <span class="hero-badge">Free to get started</span>
            <span class="hero-badge">Cancel anytime</span>
            <span class="hero-badge">No setup fees</span>
          </div>

          <div class="hero-highlight-card">
            <div>
              <div class="hero-metric">5 min</div>
              <div class="hero-metric-label">
                Average setup time
              </div>
            </div>

            <div class="hero-checklist">
              <span>• Import existing clients and invoices</span>
              <span>• Invite your accountant or team members</span>
            </div>
          </div>
        </aside>

        <!-- RIGHT SIGN UP PANEL -->
        <main class="auth-main">
          <header class="auth-header">
            <div class="auth-kicker">Get started</div>
            <h2 class="auth-title">Create your free account</h2>
            <p class="auth-subtitle">
              No credit card required. Set up your invoicing workspace in minutes.
            </p>
          </header>

          <form class="auth-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="field-group">
              <label class="field-label" for="fullName">
                Full name <span>*</span>
              </label>
              <input class="form-control" type="text" id="fullName" formControlName="fullName" placeholder="Full name*" [class.is-invalid]="registerForm.get('fullName')?.invalid && registerForm.get('fullName')?.touched" />
            </div>

            <!-- <div class="field-group">
              <label class="field-label" for="companyName">
                Company name <span>*</span>
              </label>
              <input class="form-control" type="text" id="companyName" formControlName="companyName" placeholder="Company*" [class.is-invalid]="registerForm.get('companyName')?.invalid && registerForm.get('companyName')?.touched" />
            </div> -->

            <div class="field-group">
              <label class="field-label" for="email">
                Email address <span>*</span>
              </label>
              <input class="form-control" type="email" id="email" formControlName="email" placeholder="Email*" [class.is-invalid]="registerForm.get('email')?.invalid && registerForm.get('email')?.touched" />
            </div>

            <div class="field-group">
              <label class="field-label" for="password">
                Password <span>*</span>
              </label>

              <div class="field-control">
                <input class="form-control" type="password" id="password" formControlName="password" placeholder="Enter your password" [class.is-invalid]="registerForm.get('password')?.invalid && registerForm.get('password')?.touched" />
              </div>
            </div>

            <div class="field-group">
              <label class="field-label" for="confirmPassword">
                Confirm password <span>*</span>
              </label>

              <div class="field-control">
                <input class="form-control" type="password" id="confirmPassword" formControlName="confirmPassword" placeholder="Confirm password*" [class.is-invalid]="registerForm.hasError('passwordsDontMatch') || registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched" />
              </div>
            </div>

            <div class="auth-options">
              <label class="checkbox">
                <input class="form-check-input" type="checkbox" formControlName="agreeToTAC" [class.is-invalid]="registerForm.get('agreeToTAC')?.invalid && registerForm.get('agreeToTAC')?.touched"/>
                <span>I agree to the
                    <a href="/terms" target="_blank">Terms of Service</a>
                    and
                    <a href="/privacy" target="_blank">Privacy Policy</a>.
                </span>
              </label>
            </div>

            <div class="auth-actions">
              <button type="submit" class="btn btn-get-started w-100" [disabled]="registerForm.invalid">
                Create account
              </button>
            </div>
          </form>

          <div class="auth-footer">
            Already have an account?
            <a href="/auth/login" class="link-accent">
              Log in
            </a>
          </div>
        </main>

      </div>
    </div>
  </div>
</section>